var moduleMap = {
	"./ChatModule": () => {
		return Promise.all([__webpack_require__.e(8857), __webpack_require__.e(2095), __webpack_require__.e(5912), __webpack_require__.e(108), __webpack_require__.e(4401), __webpack_require__.e(8283), __webpack_require__.e(2244), __webpack_require__.e(6737), __webpack_require__.e(812), __webpack_require__.e(2967), __webpack_require__.e(7687), __webpack_require__.e(6341), __webpack_require__.e(8887), __webpack_require__.e(7614)]).then(() => (() => ((__webpack_require__(7614)))));
	}
};
var get = (module, getScope) => {
	__webpack_require__.R = getScope;
	getScope = (
		__webpack_require__.o(moduleMap, module)
			? moduleMap[module]()
			: Promise.resolve().then(() => {
				throw new Error('Module "' + module + '" does not exist in container.');
			})
	);
	__webpack_require__.R = undefined;
	return getScope;
};
var init = (shareScope, initScope) => {
	if (!__webpack_require__.S) return;
	var name = "default"
	var oldScope = __webpack_require__.S[name];
	if(oldScope && oldScope !== shareScope) throw new Error("Container initialization failed as it has already been initialized with a different share scope");
	__webpack_require__.S[name] = shareScope;
	return __webpack_require__.I(name, initScope);
};

// This exports getters to disallow modifications
__webpack_require__.d(exports, {
	get: () => (get),
	init: () => (init)
});